import React from "react";

// Sharp geometric citrus wedge — professional, subtle degen glint.
export const MoonMark = ({ size = 28, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className} data-testid="moon-mark">
    <defs>
      <linearGradient id="mj-wedge" x1="8" y1="8" x2="40" y2="40" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFC83B" />
        <stop offset="1" stopColor="#FF6A2C" />
      </linearGradient>
    </defs>
    <path d="M8 40 A32 32 0 0 1 40 8 L8 40 Z" fill="url(#mj-wedge)" />
    <path d="M8 40 A32 32 0 0 1 40 8" stroke="#10E396" strokeWidth="2.4" strokeLinecap="round" />
    <path d="M8 40 L40 8" stroke="#08080A" strokeWidth="1.4" opacity="0.5" />
    <path d="M14 40 A26 26 0 0 1 21 21" stroke="#08080A" strokeWidth="1.2" opacity="0.35" fill="none" />
    <path d="M24 40 A22 22 0 0 1 40 18" stroke="#08080A" strokeWidth="1.2" opacity="0.35" fill="none" />
    <path d="M35 12 l1.3 3 3 1.3 -3 1.3 -1.3 3 -1.3 -3 -3 -1.3 3 -1.3 z" fill="#10E396" />
  </svg>
);

export const Wordmark = ({ className = "" }) => (
  <div className={`flex items-center gap-2.5 ${className}`} data-testid="wordmark">
    <img
      src="/moonjuice-logo.jpeg"
      alt="Wen Moon"
      width={30}
      height={30}
      className="h-[30px] w-[30px] rounded-full object-cover ring-1 ring-juice/30 shadow-[0_0_16px_rgba(255,200,59,0.25)]"
      data-testid="brand-logo"
    />
    <span className="font-black tracking-[0.22em] text-[13px] uppercase text-cream leading-none">
      Wen Moon
    </span>
  </div>
);
